// @ts-nocheck
/* eslint-disable */
export const llaPlatformMailOpenIcon = {
    data: `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.5 14.5V9.5L16 1.5L1.5 9.5V26.5C1.5 28.7092 3.29086 30.5 5.5 30.5H14.5M30 10L18.5 18.5H13.5L2 10M21.5 27.5L24.5 30.5C26 26 30.5 23.5 30.5 23.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'mail-open' as const
};